/** @format */

import { useEffect, useState, RefObject } from 'react';

const THRESHOLD = 0;

export function useInViewPort<T extends HTMLElement>(ref: RefObject<T>): boolean {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const observerOptions = {
      threshold: THRESHOLD,
    };

    const observer = new IntersectionObserver(entries => {
      setIsVisible(entries[0].isIntersecting);
    }, observerOptions);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  return isVisible;
}
